// Evergiving
import { PaymentFieldConfig } from "@evergiving/common/dist/es2015/form";

// Form components
import { Spinner } from "@/lib/components/Spinner";

// Hooks
import { Submission, SubmissionState } from "@/lib/hooks/useSubmissionState";

export const SubmissionInProgressOverlay = ({
  paymentFieldConfig,
  submission,
  onClose,
}: {
  paymentFieldConfig?: PaymentFieldConfig;
  submission: Submission;
  onClose: () => void;
}) => {
  if (submission.state === SubmissionState.Unsubmitted) {
    return null;
  }

  const submitting = submission.state === SubmissionState.Submitting;
  const requiresAction = submission.state == SubmissionState.RequiresAction;

  return (
    <div className="overlay">
      <div className="submissionProgressContainer">
        {submitting || requiresAction ? (
          <>
            {paymentFieldConfig ? (
              <div>{paymentFieldConfig.paymentProcessingText}</div>
            ) : null}
            {paymentFieldConfig && requiresAction ? (
              <div>
                <a
                  target="_blank"
                  href={submission.actionUrl}
                  rel="noopener noreferrer"
                >
                  {paymentFieldConfig.paymentAuthenticationText ||
                    "Please authenticate your card (3DS)"}
                </a>
              </div>
            ) : null}
            <Spinner className="submissionProgressSpinner" />
          </>
        ) : (
          <>
            {paymentFieldConfig ? (
              <div>{paymentFieldConfig.paymentFailedText}</div>
            ) : null}
            {"error" in submission ? <div>{submission.error}</div> : null}
            <button type="button" className="inlineButton" onClick={onClose}>
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};
